import { FeatureInfoType } from "./global/globalapi"
import type { Translation } from "./global/globals"
import type {
  SYSDialog,
  SYSLongRunningProcess,
  SYSPermissions,
  SYSFeatures,
  SYSTableDefIds,
  SYSSessionEntries,
} from "./index"
import type { ModalDialogState } from "./library/dialog/dialog"
import type { DialogsState } from "./library/dialog/sysdialogbase"
import type { FormsState } from "./library/forms/actions"
import type {
  LongRunningProcessState,
  ProcessSnackType,
} from "./library/longrunningprocesstracker/longrunningprocesstracker"
import type { ScreensState } from "./library/sysbaseelement"
import type { SnackState } from "./library/snack/snack"
import type { EditMode } from "./library/table/table"
import { tblTableSettings_ColumnFilter } from "./library/table/tablerowheadermenu/tablesettings/columnfilter/tabledef"
import { tblTableSettings_FilterSort } from "./library/table/tablerowheadermenu/tablesettings/filtersort/tabledef"

import { SYSTableSettingsState } from "./library/table/tablerowheadermenu/tablesettings/state"
import { tblAudit } from "../ovlsyscomponents/sysaudit01/features/tabledef"
import { tblEPT } from "../ovlsyscomponents/sysept01/features/tabledef"

import { tblTranslation } from "../ovlsyscomponents/systranslation01/features/tabledef"
import { tblUserAdministration_Company } from "../ovlsyscomponents/sysuseradministration01/features/company/tabledef"
import {
  tblUserAdministration_Permission,
  tblUserAdministration_ResultingPermission,
} from "../ovlsyscomponents/sysuseradministration01/features/permission/tabledef"
import { tblUserAdministration_Role } from "../ovlsyscomponents/sysuseradministration01/features/role/tabledef"
import { tblUserAdministration_User } from "../ovlsyscomponents/sysuseradministration01/features/user/tabledef"
import { tblUserAdministration_UserRole } from "../ovlsyscomponents/sysuseradministration01/features/userrole/tabledef"
import { tblUserAdministration_UserRoleTransfer } from "../ovlsyscomponents/sysuseradministration01/features/userroletransfer/tabledef"
import { LookupColumnDef } from "./library/forms/sysformelement"
import { tblSYSPortalSettings } from "../ovlsyscomponents/sysportalsettings01/features/tabledef"

let forms: FormsState = undefined

let snacks: { [key: string]: SnackState } = {}

//@ts-ignore
let dialog: { [key: string]: ModalDialogState } = {}

let translations: Translation = {}
let apiUrl = ""
let wsUrl = ""

let screens: ScreensState = {
  // screens prop will be prepared from script
  screens: undefined,
  nav: {
    nextScreen: undefined,
    nextScreenInstance: undefined,
    previousScreen: undefined,
    previousScreenInstance: undefined,
    screenCounter: 0,
    dialogCounter: 0,
    screensHistory: [],
    isNavigating: false,
  },
}

export type SYSPermissionModifiers = "A" | "M" | "D" | "R"

export type PermissionSettings = {
  modifiers: { [key in SYSPermissionModifiers]: {} }
}

export type Permissions = { [key in SYSPermissions]: PermissionSettings }

type User = {
  // there is only User or Admin for the MainContextUser
  // Of course there is fine grained Role management built in but thats handled at a different level
  role: "User" | "Admin"
  userCode: number
  userId: string
  permissions: Permissions
  isActor: boolean
  isSuperUser: boolean
  email: string
  cardCode: string
  cardName: string
  firstName: string
  lastName: string
}

type Users = {
  [key: number]: {
    features: { [key in SYSFeatures]: FeatureInfoType }
  }
}
let users: Users = undefined

let session: { [key in SYSSessionEntries]: any } = {
  Language: undefined,
  /*Token: undefined,*/
}
let user: User = {
  // its 0 because there are auth mechanisms which don't set userCode but ovl is relying on it (search eg. for userCode.toString)
  userCode: 0,
  userId: undefined,
  role: undefined,
  isActor: false,
  isSuperUser: false,
  permissions: undefined,
  email: undefined,

  cardCode: undefined,
  cardName: undefined,
  firstName: undefined,
  lastName: undefined,
}

let language = {
  translations,
  availableTranslations: [],
  translationComplete: false,
  translationFallbackLanguage: "DE",
}

let uiState = {
  isDemo: false,
  stateSavedReason: "",
  appRehydrated: false,
  appIsScreenNavigateInRehydrating: false,
  currentPopupId: "",
}

type tableRowHeaderMenuType = {
  tableDefId1: SYSTableDefIds
  tableDefId2: SYSTableDefIds
}

let tableRowHeaderMenu: tableRowHeaderMenuType = {
  // we have two ids because we could have SYSHeaderMenu open twice (Ussecase AdvancedColumnFilter)
  tableDefId1: undefined,
  tableDefId2: undefined,
}

export type _TableRowEditFormType = {
  tableDefId: SYSTableDefIds
  key: any
  editMode: EditMode
  formInitialised: boolean
}

// let tableRowEditForm: tableRowEditFormType = {
//   tableDefId: undefined,
//   key: undefined,
//   editMode: undefined,
//   formInitialised: false,
// }
export type HitListDialogStateType = {
  formType: string
  formId: string
  fieldKey: string
  selectedCallback: any
}

let hitListDialogState: HitListDialogStateType = {
  formType: undefined,
  formId: undefined,
  fieldKey: undefined,
  selectedCallback: undefined,
}
let localHitListState = { open: false }

let features = {
  SYSShellbar: {
    config: { showAdminMenuPart: true },
  },
  SYSTranslation: {
    tables: {
      SYSTranslation: {
        tableDef: {
          SYSTranslation: tblTranslation,
        },
      },
    },
  },
  SYSAudit: {
    tables: {
      SYSAudit: {
        tableDef: {
          SYSAudit: tblAudit,
        },
      },
    },
  },
  SYSEPT: {
    tables: {
      SYSEPT: {
        tableDef: {
          SYSEPT: tblEPT,
        },
      },
    },
  },

  SYSPortalSettings: {
    tables: {
      SYSPortalSettings: {
        tableDef: {
          SYSPortalSettings: tblSYSPortalSettings,
        },
      },
    },
  },
  SYSUserAdministration: {
    tables: {
      SYSUserAdministration_Role: {
        data: undefined,
        tableDef: {
          SYSUserAdministration_Role: tblUserAdministration_Role,
        },
      },

      SYSUserAdministration_User: {
        tableDef: {
          SYSUserAdministration_User: tblUserAdministration_User,
          SYSUserAdministration_UserRoleTransfer:
            tblUserAdministration_UserRoleTransfer,
        },
        clientConversion: {
          U_ITFPrtUserData: {
            jsonParse: true,
          },
        },
        ext: undefined,
      },
      SYSUserAdministration_UserRole: {
        tableDef: {
          SYSUserAdministration_UserRole: tblUserAdministration_UserRole,
        },
      },
      SYSUserAdministration_Permission: {
        tableDef: {
          SYSUserAdministration_Permission: tblUserAdministration_Permission,
          SYSUserAdministration_ResultingPermission:
            tblUserAdministration_ResultingPermission,
        },
      },

      SYSUserAdministration_Company: {
        tableDef: {
          SYSUserAdministration_Company: tblUserAdministration_Company,
        },
      },
    },
    lookups: {
      CardCode: {
        data: {},
        lookupDef: {
          CardCode: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColCardCode",
            isKey: true,
          },
          CardName: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColCardName",
          },
        },
      },
      RoleCode: {
        data: {},
        lookupDef: {
          U_RoleCode: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRole",
          },
          U_RoleDesc: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRoleDesc",
          },
          Role_U_Val1: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRoleVal1",
          },
          Role_U_Val2: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRoleVal2",
          },
          Role_U_Text1: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRoleText1",
          },
          Role_U_Text2: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRoleText2",
          },
          Role_U_Text3: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRoleText3",
          },
          Role_U_Json1: <LookupColumnDef>{
            type: "text",
            translationKey: "SYSUserAdministrationColRoleJson1",
          },
        },
      },
    },
  },

  SYSTableSettings: {
    tables: {
      SYSTableSettings_FilterSort: {
        data: {},
        schema: {},
        index: {},
        tableDef: {
          SYSTableSettings_FilterSort: tblTableSettings_FilterSort,
        },
      },

      SYSTableSettings_ColumnFilter: {
        data: {},
        schema: {},
        index: {},
        tableDef: {
          SYSTableSettings_ColumnFilter: tblTableSettings_ColumnFilter,
        },
      },
    },
  },
}

let libState = {
  dialog,
  snacks,

  tableRowHeaderMenu,
  hitListDialogState,
  localHitListState,
  tableSettings: SYSTableSettingsState,
}

export type SYSFileUploadRestrictions = {
  DefaultMaxUploadSizeInMB: number
  DefaultAllowedExtensions: string[]
  Overrides: {
    [key: string]: {
      _default: {
        AllowedExtensions: string[]
        ExtendDefaults: boolean
      }
    }
  }
}

let fileUploadRestrictions: SYSFileUploadRestrictions
let app = {
  offline: { site: false, api: false },
  discCacheVersion: Date.now(),
  isPortalTestingMode: false,
  cleanUrl: true,
  testingEmail: "",
  enablePasswordVisibility: false,
  pwRegex: "",
  backendType: "",
  ready: false,
  urlQueryString: undefined,
  clientId: undefined,
  runMode: undefined,
  actorTOTP: false,
  defaultAuthMode: "UserPw",
  fileUploadRestrictions,
  translationsVariationId: undefined,
  consoleToAudit: {
    Enabled: false,
    LogLevel: "WARN",
    ClientSendDebounceMS: 60000,
  },
}

let dialogs: {
  [key in SYSDialog]?: {
    tag: string
    rehydratable: boolean
    instance: { [key: string]: DialogsState }
  }
} = {}
let longRunningProcessTracker: {
  [key in SYSLongRunningProcess]?: {
    snack: ProcessSnackType
    snackFixedByAppDef: boolean
    lockScreen: boolean
    instance: { [key in string]: LongRunningProcessState }
    isRefresh: boolean
  }
} = {}

//let reactorPaths: string[] = []

export let ovlState = {
  app,
  user,
  session,
  users,
  language,
  uiState,
  apiUrl,
  wsUrl,
  features,
  libState,
  screens,
  forms,
  dialogs,
  longRunningProcessTracker,
  //reactorPaths,
}
